
import { Component, Vue, Prop, computed } from 'vue-property-decorator'
import { NavBar, CreateLearningVectorModal, AssessmentTemplateCard, TaskTemplateCard, LearningVectorHistCard, TermsAndConditionsLearninn, TermsAndConditionsYoutube, TermsAndConditionsWikihow } from '@/components'
import store from '../store'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
    NavBar,
    CreateLearningVectorModal,
    AssessmentTemplateCard,
    TaskTemplateCard,
    LearningVectorHistCard,
    TermsAndConditionsLearninn,
    TermsAndConditionsYoutube,
    TermsAndConditionsWikihow
  }
})

export default class ProfileView extends Vue {
  data () {
    return {
      isLoading: false,
      loggedUserId: null,
      itemSelected: null,
      learningVectors: [],
      learningVectorHists: [],
      assessmentCategories: [],
      createNewLearningVectorModal: false,
      userRoles: '',
      activeAssessmentTemplates: [],
      activeTaskTemplates: [],
      taskTypes: [],
      promoCodes: [],
      isTutor: false,
      isTeacher: false,
      isStudent: false,
      isAdmin: false,
      selectedUserId: null,
      isNewVectorBtnEnabled: false,
      formDataValid: false,
      name: '',
      createdAt: '',
      email: '',
      phone: '',
      signal: '',
      discord: '',
      instagram: '',
      facebook: '',
      linkedin: '',
      password: '',
      isMobileScreen: false,
      activeTabName: ''
    }
  }

  created () {
    this.$multiwatch(['name', 'phone', 'signal', 'discord', 'instagram', 'facebook', 'linkedin', 'password'], function () {
      const valid = this.$refs.formProfile.checkValidity()
      this.formDataValid = valid
    })
  }

  mounted () {
    window.addEventListener('resize', this.updateWindowSize)
    this.updateWindowSize()
    this.roles = store.getters.getUserRoles
    this.isTutor = this.roles ? this.roles.includes('TUTOR') : false
    this.isTeacher = this.roles ? this.roles.includes('TEACHER') : false
    this.isStudent = this.roles ? this.roles.includes('STUDENT') : false
    this.isAdmin = this.roles ? this.roles.includes('ADMIN') : false
    this.isNewVectorBtnEnabled = this.isStudent || this.isTutor
    this.getCurrUserId()
    this.selectedUserId = this.$store.getters.getSelectedUserId
    if (this.selectedUserId == null) {
      this.selectedUserId = this.loggedUserId
    }
    this.loadData()
    if (!this.isAdmin) {
      this.getUserProfile(this.loggedUserId)
    }
    this.itemSelected = this.isAdmin || this.isStudent || this.selectedUserId === this.loggedUserId ? 'profile' : 'learning'
    this.isMobileScreen = false
  }

  updateWindowSize () {
    this.isMobileScreen = window.innerWidth <= 700
  }

  updateSideBar () {
    if (window.innerWidth <= 700) {
      this.isMobileScreen = !this.isMobileScreen
    }
  }

  showPointer () {
    if (window.innerWidth <= 700) {
      return 'cursor: pointer;'
    } else {
      return ''
    }
  }

  async loadData () {
    if (!this.isAdmin && this.selectedUserId !== this.loggedUserId && !this.isStudent) {
      this.getLearningVectors()
      this.getLearningVectorHists()
      this.getAssessmentCategories()
      // this.getActiveAssessmentTemplates()
      // this.getActiveTaskTemplates()
      this.getTaskTypes()
    }
    if (this.isTutor) {
      this.getPromoCodes()
    }
    if (this.isAdmin) {
      this.getUserProfile(this.selectedUserId)
    }
  }

  getKeywords () {
    if (this.learningVectors && Array.isArray(this.learningVectors)) {
      return this.learningVectors.map(e => { return e.keyword })
    } else {
      return []
    }
  }

  getCurrUserId () {
    this.loggedUserId = store.getters.getLoggedUserId
  }

  updateSelectedUserId () {
    this.selectedUserId = this.$store.getters.getSelectedUserId
    this.loadData()
    this.itemSelected = this.isAdmin || this.isStudent || this.selectedUserId === this.loggedUserId ? 'profile' : 'learning'
    this.activeTabName = this.itemSelected === 'profile' ? 'Profile' : 'Learning'
    // this.updateSideBar()
  }

  async openProfile () {
    this.itemSelected = 'profile'
    this.activeTabName = 'Profile'
    this.updateSideBar()
  }

  async openLearning () {
    this.itemSelected = 'learning'
    this.activeTabName = 'Learning'
    this.updateSideBar()
  }

  async openAutoLearning () {
    this.itemSelected = 'autolearning'
    this.activeTabName = 'Automatic Learning'
    this.updateSideBar()
  }

  async openTermsAndConditions () {
    this.itemSelected = 'termsAndConditions'
    this.activeTabName = 'Terms And Conditions'
    this.updateSideBar()
  }

  async openActiveAssessmentTemplates () {
    this.itemSelected = 'assessments'
    this.activeTabName = 'Assessments'
    this.updateSideBar()
  }

  async openActiveTaskTemplates () {
    this.itemSelected = 'tasks'
    this.activeTabName = 'Tasks'
    this.updateSideBar()
  }

  async openPromoCodes () {
    this.itemSelected = 'promocodes'
    this.activeTabName = 'Promo codes'
    this.updateSideBar()
  }

  async openRemoveLearningVectorModal (keyword) {
    this.$buefy.dialog.confirm({
      title: 'Delete Learning Vector',
      message: 'Are you sure? You will not be able to restore it.',
      onConfirm: this.deleteLearningVector.bind(this, keyword),
      canCancel: true
    })
  }

  async deleteLearningVector (keyword) {
    this.isLoading = true
    try {
      await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/deleteUserLearningVector/${this.selectedUserId}/${keyword}`))
      this.getLearningVectors()
      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Deleted learning vector.',
        canCancel: false
      })
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not delete learning vector. Reason: ${e}`,
        canCancel: false
      })
    }
  }

  async openNewLearningVectorModal () {
    this.createNewLearningVectorModal = true
  }

  async createdNewLearningVector () {
    this.getLearningVectors()
  }

  async getLearningVectors () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getUserLearningVectors/${this.selectedUserId}`))
      this.learningVectors = resp
      this.isLoading = false
    } catch (e) {
      this.learningVectors = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get learning vectors.',
        canCancel: false
      })
    }
  }

  async getLearningVectorHists () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getUserLearningVectorHists/${this.selectedUserId}`))
      resp.map(e => {
        e.createdAt = new Date(e.createdAt)
        if (e.expireAt) {
          e.expireAt = new Date(e.expireAt)
        }
        if (e.lastUsedDate) {
          e.lastUsedDate = new Date(e.lastUsedDate)
        }
        var l = e.usedDates.map(f => {
          return new Date(f)
        })
        e.usedDates = l
        return 0
      })
      this.learningVectorHists = resp
      this.isLoading = false
    } catch (e) {
      this.learningVectorHists = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get automatic generated learning vectors.',
        canCancel: false
      })
    }
  }

  async getUserProfile (userId) {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getUserProfile/${userId}`))
      this.name = resp.name
      var dt = new Date(resp.createdAt)
      this.createdAt = dt.toLocaleString()
      this.email = resp.email
      this.phone = resp.phone
      this.signal = resp.signal
      this.discord = resp.discord
      this.facebook = resp.facebook
      this.instagram = resp.instagram
      this.linkedin = resp.linkedin

      this.userRoles = resp.roles.join(', ')
      this.isLoading = false
    } catch (e) {
      this.userProfile = null
      this.userRoles = ''
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get user profile.',
        canCancel: false
      })
    }
  }

  async getAssessmentCategories () {
    this.isLoading = true
    try {
      this.assessmentCategories = Object.keys(await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getAssessmentCategories`)))
      this.isLoading = false
    } catch (e) {
      this.assessmentCategories = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get assessment categories.',
        canCancel: false
      })
    }
  }

  async getActiveAssessmentTemplates () {
    this.isLoading = true
    try {
      this.activeAssessmentTemplates = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getActiveAssessmentTemplates/${this.selectedUserId}`))
      this.activeAssessmentTemplates.map(e => { e.active = true; return 0 })
      this.isLoading = false
    } catch (e) {
      this.activeAssessmentTemplates = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get active assessment templates.',
        canCancel: false
      })
    }
  }

  async getActiveTaskTemplates () {
    this.isLoading = true
    try {
      this.activeTaskTemplates = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getActiveTaskTemplates/${this.selectedUserId}`))
      this.activeTaskTemplates.map(e => { e.active = true; return 0 })
      this.isLoading = false
    } catch (e) {
      this.activeTaskTemplates = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get active task templates.',
        canCancel: false
      })
    }
  }

  async getTaskTypes () {
    this.isLoading = true
    try {
      this.taskTypes = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getTaskTypes`))
      this.isLoading = false
    } catch (e) {
      this.taskTypes = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get task types.',
        canCancel: false
      })
    }
  }

  async getPromoCodes () {
    this.isLoading = true
    try {
      this.promoCodes = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getAvailablePromoCodes`))
      this.isLoading = false
    } catch (e) {
      this.promoCodes = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get promo codes.',
        canCancel: false
      })
    }
  }

  async generatePromoCodes () {
    this.isLoading = true
    try {
      await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/generatePromoCodes/${1}`))
      try {
        this.getPromoCodes()
      } catch (e) {
        console.error(e)
      }
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not generate promo codes. ${e}`,
        canCancel: false
      })
    }
  }

  askToRemoveAllLearningVectorHists () {
    this.$buefy.dialog.confirm({
      title: 'Remove all ?',
      message: 'Are you sure to remove? You would not be able to recover it back.',
      onConfirm: this.removeAllLearningVectorHists,
      canCancel: true
    })
  }

  async removeAllLearningVectorHists () {
    try {
      this.isLoading = true

      var resp = await FetchWrapper.get(`${process.env.VUE_APP_SERVERURL}/deactivateAllLearningVectorHists/${this.selectedUserId}`)

      this.isLoading = false
      if (resp.error) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.$buefy.dialog.confirm({
          title: 'Success',
          message: 'All Learning Vectors removed successfully',
          onConfirm: () => {
            this.$emit('removed', resp.id)
          },
          canCancel: false
        })
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }

  async updateUser () {
    try {
      this.isLoading = true

      var data = {
        name: this.name,
        phone: this.phone,
        signal: this.signal,
        discord: this.discord,
        instagram: this.instagram,
        facebook: this.facebook,
        linkedin: this.linkedin
      }

      if (this.password) {
        data.pwd = this.password
      }

      const resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/updateUserProfile/${this.selectedUserId}`, data)

      this.isLoading = false

      window.location.href = '/home/profile'
      // this.$emit('close')
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not update user. Reason: ${e}`,
        canCancel: false
      })
    }
  }
}
